<template lang="pug">
  .registry.object-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :showSaveButton="showSaveButton"
      :hideDeleteButton="hideDeleteButton"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
        .edit-select
          select.select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs.edit-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            .modal__row
              .modal__col
                e-form-group(
                  name="name"
                  inputType="input"
                  :label="objectFieldName"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="cadastr_number"
                  inputType="input"
                  label="Кадастровый номер земельного участка"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="post_address"
                  inputType="input"
                  label="Почтовый адрес"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="is_intermunicipal"
                  :model="fields"
                  tabView="tab1"
                  caption="Межмуниципальный"
                  inputType="checkbox"
                )
                e-form-group(
                  name="is_mps"
                  :model="fields"
                  tabView="tab1"
                  caption="МПС"
                  inputType="checkbox"
                )
                e-form-group(
                  name="tkoActions"
                  :model="fields"
                  tabView="tab1"
                  :label="objectAssignment"
                  :options="getInputType === 'radio' ? Object.values(ACTIONS) : ACTIONS"
                  optionValueKey="tko_action_id"
                  optionTextKey="label"
                  labelClassName="display-block"
                  :inputType="getInputType"
                )
                e-form-group(
                  formGroupStyle="col-block multitags"
                  name="garbage_groups"
                  :model="fields"
                  tabView="tab1"
                  label="Группы обслуживаемых отходов"
                  :options="garbageGroupsOptions"
                  inputType="suggestion[]"
                )

              .modal__col
                e-form-group(
                  name="status_id"
                  inputType="select"
                  label="Статус объекта"
                  :model="fields"
                  :options="statuses"
                  :required="true"
                  :disabled="statusDisabled"
                  tabView="tab1"
                )

                .modal__block
                  e-form-group(
                    name="object_date_start"
                    label="Год ввода в эксплуатацию"
                    validationRule="number"
                    :validationAdditionalRules="{minValue: 1900, maxValue: 2100}"
                    mask="####"
                    inputType="input"
                    :model="fields"
                    tabView="tab1"
                  )

                .modal__block
                  e-form-group(
                    name="object_date_finish"
                    label="Год окончания эксплуатации"
                    validationRule="number"
                    :validationAdditionalRules="{minValue: 1900, maxValue: 2100}"
                    mask="####"
                    inputType="input"
                    :model="fields"
                    tabView="tab1"
                  )

                e-form-group(
                  name="area"
                  inputType="input"
                  label="Площадь земельного участка, в Га"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  v-if="hasForecastCapitalInvestField"
                  name="forecast_capital_invest"
                  inputType="input"
                  label="Прогнозное капитальное вложение, в руб"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  v-if="hasPlanReconstructionInvestField"
                  name="plan_reconstruction_invest"
                  inputType="input"
                  :label="objectPlanReconstructionInvestText"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  v-if="hasReo"
                  name="tko_object_category_id"
                  inputType="select"
                  label="Категория объекта"
                  :model="fields"
                  :options="categoryObject"
                  tabView="tab1"
                )
                e-form-group(
                  v-if="hasObjectNoteField"
                  name="note"
                  inputType="textarea"
                  label="Примечание"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  v-if="hasReo"
                  name="reo_id"
                  inputType="input"
                  label="ППК РЭО ID"
                  :model="fields"
                  :required="false"
                  tabView="tab1"
                )
              .modal__col
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="address"
                  :required="false"
                  :addressData="addressData"
                  :freezeLatLng="isFieldDisabled('location')"
                  tabView="tab1"
                )

                e-form-group(
                  name="orientir_distance"
                  inputType="input"
                  label="Расстояние до ближайшего населенного пункта, км"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="orientir"
                  inputType="input"
                  label="Ориентир"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

            e-modal(v-if="showFullOperatorSelectTable"
              @close="showFullOperatorSelectTable = false"
              @confirm="saveFullOperator()"
              title="Выбор эксплуатирующей организации"
            )
              slot
                e-table-checked-list(
                  selectType="radio"
                  ref="fullOperatorSelectTable"
                  @checkedChange="fullOperatorUpdate($event)"
                  :endpoint="endpointFullOperatorList"
                  :earlyCheckedItems="getEarlyCheckedFullOperator()"
                  :showPaginate="true"
                  :listTypes="fullOperatorTypes"
                  defaultListType="operator"
                )

            .body.body-table
              .table-choose-panel
                .toolbar.toolbar_no-padding.toolbar_margin-bottom
                  .toolbar__line
                    .semibold Эксплуатирующая организация
                    e-button-edit(v-if="!objectFormDisabled" @click="showFullOperatorSelectTable=!showFullOperatorSelectTable")
                .table
                  .table__row
                    .table__col.table__head Наименование
                    .table__col.table__head ИНН
                    .table__col.table__head Юр. адрес
                    .table__col.table__head Местоположение
                    .table__col.table__head Код в кадастре
                    .table__col.table__head № лицензии
                    .table__col.table__head Срок действия
                    .table__col.table__head.table__col_sticky(style="min-width: 100px")
                  .table__body
                    .table__row(v-if="fields.tko_operator && fields.tko_operator.id")
                      .table__col
                        router-link(
                          :to="getOperatorRoute(fields.tko_operator)"
                          v-html="fields.tko_operator.name"
                        )
                      .table__col {{fields.tko_operator.inn}}
                      .table__col {{fields.tko_operator.address}}
                      .table__col {{fields.tko_operator.fact_address}}
                      .table__col {{fields.tko_operator.cadastr_code}}
                      .table__col {{fields.tko_operator.license_number}}
                      .table__col {{fields.tko_operator.license_start_date ? 'с ' + fields.tko_operator.license_start_date : ''}} {{fields.tko_operator.license_finish_date ? 'по ' + fields.tko_operator.license_finish_date : ''}}
                      .table__col.table__col_sticky(style="min-width: 100px")
                        e-button-delete.row-delete.reset-btn.button.button_small.button_delete.button_icon(v-if="!objectFormDisabled" @click="deleteFullOperator()")
                    .table__row(v-else)
                      .table__col Эксплуатирующая организация отсутствует


          // ТАРИФЫ
          tko-tariff-by-date(
            v-show="tabView === 'tariffs' && hasTkoTariffByDate"
            ref="tkoTariff"
            :TARIFFS="TARIFFS"
            :tkoOperatorTariffs="fields.tkoObjectTariffs"
            :hide-calc="true"
            :operatorId="fields.tko_operator_id"
            @updateTariff="updateTariff"
          )
          tko-tariff(
            v-show="tabView === 'tariffs' && !hasTkoTariffByDate"
            :tkoOperatorTariffs="fields.tkoObjectTariffs"
            :entityId="fields.id"
            ref="tkoTariff"
            :TARIFFS="TARIFFS"
          )

          // ТЕХНОЛОГИИ
          .body-flex(v-show="tabView === 'tab2'")
            custom-technology-table(
              v-if='hasCustomObjectTechnology'
              :id="fields.id"
              :itemId="itemId"
              :formDisabled="objectFormDisabled"
              ref="technologyTable"
              tabView="tab2"
            )
            technology-table(
              v-else
              :id="fields.id"
              :itemId="itemId"
              :formDisabled="objectFormDisabled"
              ref="technologyTable"
              tabView="tab2"
            )
          // РАЗМЕЩЕНИЕ
          .body-flex(v-if="tabView === 'tab3'")
            .modal__row
              .modal__col
                e-form-group(
                  name="tko_object_type_id"
                  inputType="select"
                  label="Вид объекта"
                  :model="fields"
                  :options="tkoObjectTypeOptions"
                  tabView="tab3"
                )
                e-form-group(
                  v-if="hasProjectPowerField"
                  name="project_power"
                  :label="objectProjectPowerText"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )
                e-form-group(
                  name="project_capacity"
                  :label="objectProjectCapacityText"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )
                e-form-group(
                  v-if="hasObjectInvestment"
                  name="utilization_percent"
                  label="Доля утилизации %"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )
                e-form-group(
                  name="engineering_systems"
                  :model="fields"
                  tabView="tab3"
                  label="Инженерное обеспечение"
                  inputType="checkbox[]"
                  labelClassName="display-block"
                  @change="engineeringSystemChanged"
                  :options="engineeringSystemOptions"
                )
                button.button.button_width-auto(
                  @click="showCommentModal=true"
                ) Добавить комментарий
                e-modal(
                  v-if="showCommentModal"
                  @close="showCommentModal = false"
                  @confirm="showCommentModal = false"
                  title="Добавить комментарий"
                  :autoHeight="true"
                )
                  slot
                    .comment-wrapper
                      e-form-group(
                        name="comment"
                        label="Комментарий"
                        :model="fields"
                        inputType='textarea'
                        validationRule="double"
                        tabView="tab3"
                      )
              .modal__col
                e-form-subtitle(text="Документация")
                e-form-group(
                  name="has_monitoring"
                  :model="fields"
                  tabView="tab6"
                  label="Наличие систем мониторинга окружающей среды на объекте"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  formGroupStyle="col-block multitags"
                  name="road_types"
                  :model="fields"
                  tabView="tab6"
                  label="Характеристики подъездных путей"
                  inputType="suggestion[]"
                  :options="specOfAccessRoadsOptions"
                )

                e-form-group(
                  name="has_doc_building"
                  :model="fields"
                  tabView="tab3"
                  label="Проектная документация на строительство объекта"
                  inputType="radio"
                  :options="yeasOrNo"
                )
                e-form-group(
                  name="has_doc_recultivation"
                  :model="fields"
                  tabView="tab3"
                  label="Проектная документация на рекультивацию земельного участка"
                  inputType="radio"
                  :options="yeasOrNo"
                )
                e-form-group(
                  name="has_expertise"
                  :model="fields"
                  tabView="tab3"
                  label="Положительное заключение гос. экологической экспертизы"
                  inputType="radio"
                  :options="yeasOrNo"
                )
                e-form-group(
                  name="number"
                  label="Номер документа"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.number"
                )
                e-form-group(
                  name="dt"
                  inputType="calendar"
                  type="date"
                  label="От"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.dt"
                )
                e-form-group(
                  name="organization"
                  label="Выдавшая организация"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.organization"
                )
              .modal__col
                e-form-subtitle(text="ГРОРО")
                e-form-group(
                  name="has_groro"
                  :model="fields"
                  tabView="tab3"
                  label="Включение объекта в ГРОРО"
                  inputType="radio"
                  :options="yeasOrNo"
                )
                e-form-group(
                  name="dt"
                  type="date"
                  inputType="calendar"
                  label="От"
                  :disabled="disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.dt"
                )
                e-form-group(
                  name="number"
                  label="Номер документа"
                  :disabled="disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.number"
                )
                e-form-group(
                  name="groro_number"
                  label="Номер ГРОРО"
                  :disabled="disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.groro_number"
                )
            object-investment(v-if="hasObjectInvestment")
            object-fkko(v-if="itemId")

          // ДОКУМЕНТЫ
          .body-flex(v-if="tabView === 'tab4'")
            .modal__row
              .modal__col
                e-form-subtitle(text="На земельный участок")
                e-form-group(
                  label="Свидетельство регистрации права, номер"
                  name="number"
                  validationRule="number"
                  :model="registrationDocumentsModel['1']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['1']"
                  tabView="tab4"
                  type="date"
                )

                e-form-group(
                  label="Договор аренды, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                  type="date"
                )
                e-form-group(
                  label="Срок действия до"
                  inputType="calendar"
                  name="date_finish"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                  type="date"
                )


              .modal__col
                e-form-subtitle(text="На установку")

                e-form-group(
                  label="Свидетельство регистрации права, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['3']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['3']"
                  tabView="tab4"
                  type="date"
                )


                e-form-group(
                  label="Договор аренды, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                  type="date"
                )
                e-form-group(
                  label="Срок действия до"
                  inputType="calendar"
                  name="date_finish"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                  type="date"
                )


          // СВЕДЕНИЯ ПО ОТХОДАМ
          .body-flex(v-if="tabView === 'tab5'")
            r-registry-object-garbage-table(
              :fields="fields"
              :id="fields.id"
              :itemId="itemId"
              :formDisabled="objectFormDisabled"
              ref="garbageTable"
              tabView="tab5"
            )

          // Х-КА
          .body-flex(v-if="tabView === 'tab6'")
            object-characteristics(
            :fields="fields"
            :characteristics="characteristics"
            :characteristicYears="characteristicYears"
            :hasForecast="hasForecast"
            :hasLeftoverCapacity="hasLeftoverCapacity"
            :tkoObjectStateOptions="tkoObjectStateOptions"
            @setCharacteristicFields='setCharacteristicFields'
            )
          // Маршруты
          .body-flex(v-if="tabView === 'routes'")
            routes-table(:fields="fields" :id="fields.id" ref="routesTable" tabView="routes")

          // Журнал изменений
          .body-flex(v-if="tabView === 'tab7'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )

          // Документы
          .body-flex(v-if="tabView === 'tab8' && itemId")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
import { core, tko } from '@/api/api-endpoints'
import { REGION_CONFIG } from '@/config/regions'
import hasMixin from '@/mixins/has-mixin'
import textMixin from '@/mixins/text-mixin'
import { StorageId, BurialId, AccommodationId } from '@/config/config'
import objectForm from './mixins/object-form'
import TechnologyTable from './components/technology-table'
import CustomTechnologyTable from './components/custom-technology-table'
import RoutesTable from './components/routes-table'
import TkoTariff from './components/tko-tariff'
import ObjectInvestment from './components/object-investment'
import ObjectFkko from './components/object-fkko'
import TkoTariffByDate from '../registry/components/tko-tariff-by-date'
import ObjectCharacteristics from './components/object-characteristics'

export default {
  components: {
    TkoTariff,
    RoutesTable,
    TechnologyTable,
    CustomTechnologyTable,
    ObjectInvestment,
    ObjectFkko,
    TkoTariffByDate,
    ObjectCharacteristics,
  },
  mixins: [objectForm, hasMixin, textMixin],
  data() {
    return {
      errors: null,
      showCommentModal: false,
    }
  },
  computed: {
    // for use in src/app/registry/OperatorAllUpdate
    // with duplicate id route
    itemId() {
      return this.$route.params.objectId || this.$route.params.id || null
    },
    moduleId() {
      return this.moduleIds['tko-object']
    },
    tabs() {
      const tabs = [
        { tab1: 'Общие сведения' },
        { tab2: 'Технологии' },
        { tab3: 'Сведения из проектной документации' },
      ]
      if (this.hasObjectRegistrationDocuments) {
        tabs.push({ tab4: this.objectDocNameTab })
      }
      if (this.fields.id) {
        tabs.push({ tab5: 'Сведения по отходам' })
      }
      if (this.hasObjectRoutes) {
        tabs.push({ routes: 'Маршруты' })
      }
      if (this.hasObjectTarifs && this.itemId) {
        tabs.push({ tariffs: 'Тарифы' })
      }
      if (this.characteristics[this.characteristicYear]) {
        tabs.push({ tab6: 'Характеристика' })
      }
      if (this.fields.id && this.hasChangeLog) {
        tabs.push({ tab7: 'Журнал изменений' })
        tabs.push({ tab8: 'Хранилище документов' })
      }
      return tabs
    },
    hasLeftoverCapacity() {
      const neededCapacityActions = [StorageId, AccommodationId, BurialId]
      return this.fields.tkoActionsArray.some((item) =>
        neededCapacityActions.includes(item)
      )
    },
    hasForecast() {
      if (!this.characteristics[this.characteristicYear]) {
        return false
      }
      return (
        this.characteristics[this.characteristicYear]?.tko_object_id &&
        this.characteristics[this.characteristicYear]?.power &&
        this.characteristics[this.characteristicYear]?.area_garbage &&
        this.characteristics[this.characteristicYear]?.part_fuel_production &&
        this.characteristics[this.characteristicYear]?.free_power &&
        this.characteristics[this.characteristicYear]?.free_power_cub
      )
    },
    getInputType() {
      this.fields.tkoActionsArray = [...this.fields.tkoActions]

      if (REGION_CONFIG.inputTypeTkoAction === 'radio') {
        this.fields.tkoActions = REGION_CONFIG.setValueTkoActions(
          this.fields.tkoActions
        )
      }
      return REGION_CONFIG.inputTypeTkoAction
    },
  },
  methods: {
    getDocumentsEndpoint(id) {
      return core.documents(id)
    },
    getTkoOperatorEndpoint() {
      return core.statuses({ fields: 'tko_operator' })
    },
    getCollectionEndpoint() {
      return core.collection(
        'garbage_group,status,engineering_system,road_type,tko_object_type,tko_object_state, tko_object_category',
        { query: { type: 'tko_object' } }
      )
    },
    getDeleteUrl(id) {
      return tko.objectDelete(id)
    },
    getUpdateOrCreateUrl() {
      let itemId = this.$route.params.objectId || this.$route.params.id || null
      return tko.objectUpdateOrCreate(itemId)
    },
    getItemEndpoint(route) {
      let itemId = route.params.objectId || route.params.id || null
      if (!itemId) {
        return null
      }
      return tko.object(itemId)
    },
    updateTariff(tariffs) {
      this.fields.tariffs = tariffs.tariffs
      this.fields.tkoObjectTariffs = tariffs.tariffs
    },
    updateFreePower() {
      this.fields.tko_object_params = this.fields.tko_object_params.map(
        (item) => {
          if (!Number(item.free_power)) {
            item.free_power = this.fields.project_capacity
          }
          return item
        }
      )
    },
  },
  created() {
    this.fields = { ...this.fields, ...this.$route.params }
    this.updateFreePower()
  },
}
</script>
<style lang="scss">
.comment-wrapper {
  padding: 0 20px;
}
</style>
